<!-- 关闭订单弹框 -->
<template>
  <div class="container">
    <el-dialog :visible.sync="dialogVisible" width="50%" center>
      <div class="p1">操作人： 此处带入操作人姓名 电话 公司信息</div>
      <p class="p2"><span>*</span> 关闭理由：</p>
      <div class="main">
        <div class="left">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6 }"
            placeholder="请输入内容"
            v-model="textarea2"
          >
          </el-input>
        </div>
        <div class="right">
          <p class="p3">快捷输入：</p>
          <p style="margin-right: 0.06rem">平台无库存</p>
          <p>恶意订单</p>
        </div>
      </div>
      <div class="p4">
        <P>订单号：</P>
        <P>子订单号：</P>
        <P>订单金额：￥123456</P>
        <p style="margin-bottom:0.24rem">付款状态：已付款</p>
        <p>
          一旦关闭订单， 订单金额将自动生成退款订单并退回到客户的原支付渠道。
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      textarea2: "",
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.container {
  .p1 {
    color: rgba(16, 16, 16, 1);
    font-size: 0.14rem;
    font-family: SourceHanSansSC-regular;
    margin-bottom: 0.3rem;
  }
  .p2 {
    color: rgba(16, 16, 16, 1);
    font-size: 0.14rem;
    font-family: SourceHanSansSC-regular;
    margin-bottom: 0.12rem;
    span {
      font-size: 0.24rem;
      font-weight: bold;
      color: red;
    }
  }
  .main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 0.24rem;
    .left {
      flex: 1;
      margin-right: 0.12rem;
    }
    .right {
      color: rgba(16, 16, 16, 1);
      font-size: 0.14rem;
      font-family: SourceHanSansSC-regular;
      .p3 {
        margin-bottom: 0.3rem;
      }
    }
  }
  .p4 {
    color: rgba(16, 16, 16, 1);
    font-size: 0.14rem;
    font-family: SourceHanSansSC-regular;
    p {
        margin-bottom: 0.06rem;
    }
  }
}
</style>
